export default __webpack_public_path__ + "cdffa2707762c15c83273a1d9ea12df0.png";